import * as Actions from './actions'
import {initialState} from '../store/initialState'

export const ProductsReducer = (state = initialState.products, action) =>{
    switch(action.type){
        case Actions.DELETE_PRODUCTS:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.FETCH_PRODUCTS:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.INIT_PRODUCTS:
            return {
                ...initialState.products
            };
        default:
            return state
    }
}